<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » アップロードファイル一覧（プレゼント用）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>アップロードファイル一覧（プレゼント用）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/uploader-dl.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択したファイルを削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ファイル選択
        </div>
        <div class="manual-explain">
          ファイルをシステムにアップロードします。<br>
          ファイルを選択ボタンからアップロードするか、またはドラッグ&ドロップでもアップロード可能です。<br>
          <span class="manual-explain-notes">
            ※ファイルを選択する前に「画像圧縮」を選択してください。<br>
            &nbsp;&nbsp;圧縮方式は「圧縮する（500KB以下へ）」「圧縮する（640px以下へ）」「圧縮しない」が選択可能です。<br>
            &nbsp;&nbsp;画像のサイズが大きいほど通信料が掛かりユーザーの負担となりますので、圧縮することをお勧めします。<br>
          </span>
          <span>
            ※各画像についての推奨サイズ（縦横比）は以下になります。<br>
            &nbsp;&nbsp;ロゴ画像：1 : 4.5（例）高さ約150px、幅700px<br>
            &nbsp;&nbsp;メイン画像：1 : 1（例）高さ1400px、幅1400px<br>
          </span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          アップロードファイル一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: 名称
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> アップロードファイル一覧
        </div>
        <div class="manual-explain">
          アップロード済みファイルの一覧が表示されます。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Usage Guide Top</a> &raquo; Uploaded Files List (for Gifts) Explanation
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Uploaded Files List (for Gifts) Explanation</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_uploader-dl.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Delete button
        </div>
        <div class="manual-explain">
          Clicking this will delete the selected files. <br>
          The button is activated by checking the delete checkbox in the list.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Select File
        </div>
        <div class="manual-explain">
          Upload files to the system. <br>
          Files can be uploaded by clicking the "Select File" button or by dragging and dropping. <br>
          <span class="manual-explain-notes">
            *Please select "Image Compression" before selecting files. <br>
            &nbsp;&nbsp;Compression methods available are: "Compress (to under 500KB)", "Compress (to under 640px)", and "Do not compress". <br>
            &nbsp;&nbsp;Larger image sizes incur higher communication costs and burden users, so compression is recommended. <br>
          </span>
          <span>
            *Recommended image sizes (aspect ratio) for each image are as follows: <br>
            &nbsp;&nbsp;Logo image: 1 : 4.5 (e.g.) Height approx. 150px, Width 700px <br>
            &nbsp;&nbsp;Main image: 1 : 1 (e.g.) Height 1400px, Width 1400px<br>
          </span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the uploaded file list. <br>
          *Target for filtering: Name
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Uploaded Files List
        </div>
        <div class="manual-explain">
          A list of uploaded files is displayed. <br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>
</div>